<template>
    <div class="a-vs-b--bottom-summary">
        <div class="a-vs-c--single-rating">
          <div>
            <div class="a-vs-c-success-secondary"></div>
            <span>{{ currentMatch.Win }} ({{ currentMatch.WinPercentage }}%)</span>
          </div>
          <span>{{ match.HomeTeam }}</span>
        </div>
        <div class="a-vs-c--single-rating">
          <div>
            <div class="a-vs-c-neutral-secondary"></div>
            <span>{{ currentMatch.Draw }} ({{ currentMatch.DrawPercentage }}%)</span>
          </div>
          <span>{{ $t("draw") }}</span>
        </div>
        <div class="a-vs-c--single-rating">
          <div>
            <div class="a-vs-c-danger-secondary"></div>
            <span>{{ currentMatch.Lose }} ({{ currentMatch.LosePercentage }}%)</span>
          </div>
          <span>{{ match.AwayTeam }}</span>
        </div>
      </div>
</template>
<script>
export default {

  props: {
    currentMatch: {
      type: Object,
      required: true
    },
    match: {
      type: Object,
      required: true
    }
  }
}
</script>
